<div class="container">
  <div class="lds-dual-ring"></div>

  <div class="progress">{{ progressStep }}%</div>

  <div class="subtext">
    {{ 'REFRESH_TOKEN_MODAL.PLEASE_WAIT' | translate }}
  </div>
</div>
